import React from 'react';
import { Info } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

/**
 * Ícono "i" que al pasar el mouse explica de dónde sale una cifra. `children` admite texto
 * o JSX (listas, fórmulas).
 */
const InfoTip = ({ children, className = '', side = 'top' }) => (
  <TooltipProvider delayDuration={100}>
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          aria-label="Cómo se calcula"
          className={`inline-flex items-center justify-center text-[#7A8597] hover:text-[#0F3460] dark:text-gray-500 dark:hover:text-gray-200 align-middle ${className}`}
          onClick={(e) => e.preventDefault()}
        >
          <Info className="h-3.5 w-3.5" />
        </button>
      </TooltipTrigger>
      <TooltipContent side={side} className="max-w-sm text-xs leading-relaxed normal-case tracking-normal font-normal text-left">
        {children}
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);

export default InfoTip;
